<div :class="'itemHelperLine ' + orientation" :style="getPos">
  <div class="lineInfo">
    <span v-html="infoText"></span>
    {{ $t("cm") }}
  </div>
</div>